import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { withTranslation, Trans } from 'react-i18next';

export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    pages: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    t:PropTypes.func
  };

  render() {
    // console.log("Props",this.props)
    return (
      <div className="pages-default-page">
        Page Content: pages/DefaultPage
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pages: state.pages,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/pages/DefaultPage.js